<div class="table-container">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
      <td mat-cell *matCellDef="let row">
        <div class="amount">
          @if (row.isAggregatedAmount) {
            Σ&nbsp;
          }
          {{ getCurrentStockAmount(row) }}
        </div>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ numberOfProducts }}
      </td>
    </ng-container>

    <ng-container matColumnDef="bestBefore">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Next Due Date</th>
      <td mat-cell *matCellDef="let row">
        {{ row.bestBefore <= '2999' ? (row.bestBefore | date: 'dd-MM-yyyy') : '-' }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{ averageDueDate ? (averageDueDate | date: 'dd-MM-yyyy') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button aria-label="expand row" (click)="expandRow($event, row)" color="primary">
          <mat-icon>{{ expandedRow === row ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </button>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="columns.length">
        <div [@detailExpand]="row === expandedRow ? 'expanded' : 'collapsed'">
          @if (row.subStock && row.subStock.length > 0) {
            <ul>
              @for (subStockItem of row.subStock; track $index) {
                <li>
                  <app-badge
                    [colourClass]="getCurrentStockColourClass(subStockItem)"
                    [value]="subStockItem.product.name" />

                  <app-badge
                    [colourClass]="getCurrentStockColourClass(subStockItem)"
                    [value]="getCurrentStockAmount(subStockItem)" />

                  <app-badge
                    [colourClass]="getCurrentStockColourClass(subStockItem)"
                    [value]="getCurrentStockBestBefore(subStockItem)" />

                  <app-badge
                    [colourClass]="getCurrentStockColourClass(subStockItem)"
                    [value]="getCurrentStockValue(subStockItem)" />

                  @if (productContextData.get(subStockItem.product.id)) {
                    <app-grocy-product-actions-menu
                      [productContextData]="productContextData.get(subStockItem.product.id)!"
                      (event)="productActionEvent($event)" />
                  }
                </li>
              }
            </ul>
          } @else {
            No sub stock items found.
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="product.name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
      <td mat-cell *matCellDef="let row">
        <app-badge
          [colourClass]="getCurrentStockColourClass(row)"
          [link]="getProductLink(row)"
          [value]="row.product.name" />
      </td>
      <td mat-footer-cell *matFooterCellDef>Total</td>
    </ng-container>

    <ng-container matColumnDef="productGroup">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Product Group</th>
      <td mat-cell *matCellDef="let row">
        <app-badge [colourClass]="getCurrentStockColourClass(row)" [value]="row.productGroup.name" />
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
      <td mat-cell *matCellDef="let row">
        {{ row.value | currency: 'SEK' }}
      </td>
      <td mat-footer-cell *matFooterCellDef>
        {{
          totalValue.toLocaleString('sv-SE', {
            style: 'currency',
            currency: 'SEK',
          })
        }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: columns"
      class="expandable-row expandable-row-with-data"
      [class.expanded-row]="expandedRow === row"
      (click)="expandRow($event, row)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="row-expansion"></tr>
    <tr mat-footer-row *matFooterRowDef="columns; sticky: true"></tr>
  </table>
</div>
